module.exports = __webpack_public_path__ + "01_medium_black.f990e4ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_medium_black.png
// module id = wnZH
// module chunks = 0